import React from "react";
import { NavLink } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DashboardIcon from "@material-ui/icons/DashboardOutlined";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCartOutlined";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";
import BarChartIcon from "@material-ui/icons/BarChartOutlined";
import LayersIcon from "@material-ui/icons/LayersOutlined";
import { withStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import { ReactComponent as LogoA } from 'assets/dashboard/equipments.svg';
import { ReactComponent as LogoB } from 'assets/dashboard/iconfinder.svg';
import { ReactComponent as LogoC } from 'assets/dashboard/outline_bar_chart.svg';
import { ReactComponent as LogoD } from 'assets/dashboard/outline_dashboard.svg';
import { ReactComponent as LogoE } from 'assets/dashboard/outline_layers.svg';
import { ReactComponent as LogoF } from 'assets/dashboard/outline_people.svg';

const styles = theme => ({
  label: {
    color: "rgb(51, 73, 84)",
  },
  icon: {
    color: "rgb(35, 97, 146)",
  },
});

const listItemText = {
  variant: "body2",
};

const MainNavLink = ({ to, children, ...restProps }) => (
  <NavLink to={to} {...restProps} activeStyle={{ fontWeight: "bold" }}>
    {children}
  </NavLink>
);

const NavigationList = ({ classes }) => (
  <div>
    <List>
      <ListItem button component={MainNavLink} to="/dashboard">
        <ListItemIcon className={classes.icon}>
          <LogoD />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={listItemText}
          className={classes.label}
          primary="Dashboard"
        />
      </ListItem>
    </List>
    <Divider />
    <List>
    <ListItem button component={MainNavLink} to="/notifications">
        <ListItemIcon className={classes.icon}>
          <LogoE />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={listItemText}
          className={classes.label}
          primary="Notifications"
        />
      </ListItem>
      <ListItem button component={MainNavLink} to="/scheduler">
        <ListItemIcon className={classes.icon}>
          <LogoB />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={listItemText}
          className={classes.label}
          primary="
          Scheduler"
        />
      </ListItem>
      <ListItem button component={MainNavLink} to="/customers">
        <ListItemIcon className={classes.icon}>
          <LogoF />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={listItemText}
          className={classes.label}
          primary="Customers"
        />
      </ListItem>
      <ListItem button component={MainNavLink} to="/equipments">
        <ListItemIcon className={classes.icon}>
          <LogoA />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={listItemText}
          className={classes.label}
          primary="Equipments"
        />
      </ListItem>
      <ListItem button component={MainNavLink} to="/regions">
        <ListItemIcon className={classes.icon}>
          <LogoC />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={listItemText}
          className={classes.label}
          primary="Regions"
        />
      </ListItem>
    </List>
  </div>
);

export default withStyles(styles)(NavigationList);
